import React from "react";



const Navbar = () => {
    return (
        <div className="header-and-banner-con w-100 float-left position-relative" style={{ marginTop: "-20px" }}>
            <div className="header-and-banner-inner-con">
                <header className="main-header">

                    <div className="container pl-0 pr-0">
                        <div className="header-con">
                            <nav className="navbar navbar-expand-lg navbar-light p-0">
                                <a className="navbar-brand p-0 " href="" style={{ fontSize: '30px', fontWeight: 'bold', color: "#6F34FE" }}>
                                    My Portfolio
                                    {/* <img src="assets/image/logo-img.png" alt="logo-img" className="img-fluid" /> */}
                                </a>
                                <button className="navbar-toggler p-0 collapsed" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                    <span className="navbar-toggler-icon"></span>
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                                    <ul className="navbar-nav ml-auto">
                                        <li className="nav-item active pl-0">
                                            <a className="nav-link p-0 is-active" href="index.html">Home<span className="sr-only">(current)</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link p-0" href="#service-con">Services</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link p-0" href="#about-con">About</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link p-0" href="#Portfolio">Portfolio</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link p-0" href="#testimonials">Testimonials</a>
                                        </li>
                                        {/* <li className="nav-item">
                                <a className="nav-link p-0" href="#blog">Blog</a>
                             </li> */}
                                    </ul>
                                    <div className="d-inline-block contact">
                                        <a href="#Contact">Contact</a>
                                    </div>

                                    <div className="d-inline-block contact">
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>

                </header>
                <section className="banner-main-con" id="home">
                    <div className="container pl-0 pr-0">

                        <div className="footer-social-icon banner-social-icon mb-0">
                            <ul className="mb-0 list-unstyled">
                                <li className="mt-3 mb-3">
                                    <a href="https://wa.me/00923003929585" target="_blank"><i className="fab fa-whatsapp-square d-flex align-items-center justify-content-center" style={{ fontSize: '25px' }}></i></a>
                                </li>
                                <li className="mt-3 mb-3">
                                    <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/" target="_blank"><i className="fab fa-linkedin-in d-flex ml-0 mr-0 align-items-center justify-content-center" style={{ fontSize: '25px' }}></i></a>
                                </li>
                                <li className="mt-3 mb-3">
                                    <a href="https://github.com/Sajjadlaghari"><i className="fab fa-github d-flex align-items-center justify-content-center ml-0 mr-0 " style={{ fontSize: '25px' }}></i></a>
                                </li>
                                <li className="mt-3 mb-3 " style={{ marginLeft: "-40px" }}>
                                    <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                                        <img src="assets/image/fiverr_logo_icon_169172.png" />
                                    </a>
                                </li>

                                <li className="mb-3 mt-3">
                                    <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                                        <img src="assets/image/upwork_logo_icon_170310.png" style={{ width: "40px", marginRight: "", }} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="banner-con text-lg-left text-center">
                            <div className="row">
                                <div className="col-lg-7 col-sm-12 d-flex justify-content-center flex-column">
                                    <div className="banner-left-con wow slideInLeft">
                                        <div className="banner-heading">
                                            <h2>Hello, Iam</h2>
                                            <ul className="dynamic-txts">
                                                <li><h1>Sajjad Ali</h1></li>
                                                <li><h1>Sajjad Ali</h1></li>
                                                <li><h1>Sajjad Ali</h1></li>
                                                <li><h1>Sajjad Ali</h1></li>
                                            </ul>
                                            <p>Iam a Full Stack
                                                Web and Mobile Application Developer
                                            </p>
                                        </div>
                                        <div className="banner-btn generic-btn d-inline-block">
                                            <a href="#Contact">Hire Me</a>
                                        </div>
                                        <a href="#Portfolio" className="See-btn">See My Work</a>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-sm-12">
                                    <div className="banner-right-con position-relative wow slideInRight" id="banner-right-con">
                                        <figure className="mb-0">
                                            <img src="assets/image/image.png" alt="banner-right-img" id="banner-right-img"  />
                                        </figure>
                                        <div className="best-award-con d-inline-block wow bounceInUp" data-wow-duration="1s" data-wow-delay="1s">
                                            <div className="best-award-inner-con">
                                                {/* <figure className="mb-0">
                                      <img src="assets/image/cup-img.png" alt="cup-img" className="img-fluid" />
                                   </figure> */}
                                                {/* <div className="best-award-title">
                                      <p className="mb-0">Best Design<br />
                                         Award.
                                      </p>
                                   </div> */}
                                            </div>
                                        </div>
                                        <div className="best-award-con d-inline-block happy-con wow bounceInUp " data-wow-duration="1s" data-wow-delay="1s">
                                            {/* <div className="best-award-inner-con text-center">
                                   <figure>
                                      <img src="assets/image/admin-icon.png" alt="admin-icon" className="img-fluid" />
                                   </figure>
                                   <div className="best-award-title d-inline-block ml-0">
                                      <p className="mb-0 d-inline-block count">4</p>
                                      <p className="mb-0 d-inline-block">k+</p>
                                      <span className="d-block">Happy<br />
                                      Customers</span>
                                   </div>
                                </div> */}
                                        </div>
                                        <div className="cursor"></div>
                                        <div className="cursor2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>

    )
}

export default Navbar